import { API_URLS } from "../../../config";
import {
  storeAllConversationUsersList,
  storeAttendanceList,
  storeEmployeeList,
  storeEmployeeProfile,
  storeUserDashboard,
  storeUserDropdown,
  storeUserList,
  storeUserProfile,
  turnOffLoading,
} from "../../redux/slices/adminListSlice";
import {
  loginFailed,
  loginSuccessful,
  storeEmergencyContact,
} from "../../redux/slices/userSlice";
import { CallApi } from "./api/callApi";
import { call, put } from "redux-saga/effects";
export function* loginUserSaga(action) {
  try {
    const data = action.payload;
    //console?.log(data);
    const resp = yield call(
      CallApi.POST,
      API_URLS.USERS.LOGIN,
      data?.data,
      data?.token
    );
    // //console?.log(resp, API_URLS.USERS.LOGIN)
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data?.success
    ) {
      // //console?.log('saga call');
      yield put(loginSuccessful(resp?.data?.data));
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      // //console?.log(resp?.data.success);
      if (resp?.data?.success === false) {
        yield put(loginFailed());
      }
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    yield put(loginFailed());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}

export function* resetPasswordSaga(action) {
  try {
    const data = action.payload;
    //console?.log(data);
    const resp = yield call(
      CallApi.POST,
      API_URLS.USERS.RESET_PASSWORD,
      data?.data,
      data?.token
    );
    // //console?.log(resp, API_URLS.USERS.LOGIN)
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      // //console?.log('saga call');
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    // //console?.log('inside catch', e);
    yield put(loginFailed());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}

export function* changePasswordSaga(action) {
  try {
    const data = action.payload;
    const resp = yield call(
      CallApi.POST,
      API_URLS.USERS.CHANGE_PASSWORD,
      data?.data,
      data?.token
    );
    // //console?.log(resp, API_URLS.USERS.LOGIN)
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      // //console?.log('saga call');
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    // //console?.log('inside catch', e);
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}

export function* forceResetPasswordSaga(action) {
  try {
    const data = action.payload;
    const { id } = data?.data;
    const resp = yield call(
      CallApi.POST,
      `${API_URLS.USERS.RESET_PASSWORD}/${id}`,
      null,
      data?.token
    );
    // //console?.log(resp, API_URLS.USERS.LOGIN)
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      // //console?.log('saga call');
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    // //console?.log('inside catch', e);
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}

export function* listUserSaga(action) {
  try {
    const data = action.payload;
    const resp = yield call(
      CallApi.GET,
      API_URLS.USERS.ROUTE,
      data?.data,
      data?.token
    );
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      if (data?.data?.page) {
        yield put(storeUserList(resp?.data?.data));
      } else {
        yield put(storeUserDropdown(resp?.data?.data));
      }
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      yield put(turnOffLoading());
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    yield put(turnOffLoading());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}

export function* fetchMyProfileSaga(action) {
  try {
    const data = action.payload;
    const resp = yield call(
      CallApi.GET,
      API_URLS.USERS.PROFILE,
      data?.data,
      data?.token
    );
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      // yield put(storeMyProfile(resp?.data?.data));
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      yield put(turnOffLoading());
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    yield put(turnOffLoading());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}
export function* updateMyProfilePictureSaga(action) {
  try {
    const data = action.payload;
    const resp = yield call(
      CallApi.PUT,
      API_URLS.FILES.PROFILE,
      data?.data,
      data?.token
    );
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      // yield put(storeMyProfile(resp?.data?.data));
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      yield put(turnOffLoading());
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    yield put(turnOffLoading());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}

export function* fetchUserProfileSaga(action) {
  try {
    const data = action.payload;
    const { id } = data?.data;
    const resp = yield call(
      CallApi.GET,
      `${API_URLS.USERS.PROFILE}/${id}`,
      null,
      data?.token
    );
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      yield put(storeUserProfile(resp?.data.data));

      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      yield put(turnOffLoading());
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    yield put(turnOffLoading());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}
export function* fetchEmployeeProfileSaga(action) {
  try {
    const data = action.payload;
    const { id } = data?.data;
    const resp = yield call(
      CallApi.GET,
      `${API_URLS.USERS.EMPLOYEE.ROUTE}/${id}`,
      null,
      data?.token
    );
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      yield put(storeEmployeeProfile(resp?.data.data));
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      yield put(turnOffLoading());
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    yield put(turnOffLoading());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}
export function* fetchUserDashboardSaga(action) {
  try {
    const data = action.payload;
    const resp = yield call(
      CallApi.GET,
      API_URLS.USERS.DASHBOARD,
      null,
      data?.token
    );
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      yield put(storeUserDashboard(resp?.data.data));
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      yield put(turnOffLoading());
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    yield put(turnOffLoading());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}

export function* updateUserSaga(action) {
  try {
    //console?.log(action.payload);
    const data = action.payload;
    const { id, ...userData } = data.data;
    const resp = yield call(
      CallApi.PATCH,
      `${API_URLS.USERS.ROUTE}/${id}`,
      userData,
      data?.token
    );
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      yield put(turnOffLoading());
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    yield put(turnOffLoading());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}
export function* updateEmployeeProfileSaga(action) {
  try {
    //console?.log(action.payload);
    const data = action.payload;
    const { id, ...userData } = data.data;
    const resp = yield call(
      CallApi.PATCH,
      API_URLS.USERS.PROFILE,
      userData,
      data?.token
    );
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      yield put(turnOffLoading());
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    yield put(turnOffLoading());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}

export function* listEmployeeSaga(action) {
  try {
    const data = action.payload;
    const resp = yield call(
      CallApi.GET,
      API_URLS.USERS.EMPLOYEE.ROUTE,
      data?.data,
      data?.token
    );
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      yield put(storeEmployeeList(resp?.data.data));
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      yield put(turnOffLoading());
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    yield put(turnOffLoading());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}

export function* listAttendanceSaga(action) {
  try {
    const data = action.payload;
    const resp = yield call(
      CallApi.GET,
      API_URLS.USERS.ATTENDANCE.ROUTE,
      data?.data,
      data?.token
    );
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      yield put(storeAttendanceList(resp?.data.data));
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      yield put(turnOffLoading());
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    yield put(turnOffLoading());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}

export function* assignEmployeeToTLSaga(action) {
  try {
    const data = action.payload;
    const resp = yield call(
      CallApi.POST,
      API_URLS.USERS.ASSIGN_TO_TL,
      data?.data,
      data?.token
    );
    // //console?.log(resp, API_URLS.USERS.LOGIN)
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      // //console?.log('saga call');

      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    // //console?.log('inside catch', e);
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}

/****************************ALL Conversations *************************** */

export function* getAllConversationsUsersSaga(action) {
  try {
    const data = action.payload;
    const resp = yield call(
      CallApi.GET,
      API_URLS.USERS.CONVERSATION.ALL_ROOMS,
      data?.data,
      data?.token
    );
    // //console?.log(resp, API_URLS.USERS.LOGIN)
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      // //console?.log('saga call');

      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    // //console?.log('inside catch', e);
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}
export function* getAllConversationMessagesSaga(action) {
  try {
    const data = action.payload;
    const { id } = data.data;
    const resp = yield call(
      CallApi.GET,
      `${API_URLS.USERS.CONVERSATION.MESSAGE}/${id}`,
      null,
      data?.token
    );
    // //console?.log(resp, API_URLS.USERS.LOGIN)
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      // //console?.log('saga call');

      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    // //console?.log('inside catch', e);
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}




export function* updateEmergencyContactSaga(action) {
  try {
    //console?.log(action.payload);
    const data = action.payload;
    const { id, ...userData } = data.data;
    const resp = yield call(
      CallApi.PATCH,
      `${API_URLS.USERS.EMPLOYEE.UPDATE_EMERGENCY_CONTACT}/${id}`,
      userData,
      data?.token
    );
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      yield put(turnOffLoading());
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    yield put(turnOffLoading());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}
export function* createEmergencyContactSaga(action) {
  try {
    //console?.log(action.payload);
    const data = action.payload;
    const { id, ...userData } = data.data;
    const resp = yield call(
      CallApi.POST,
      API_URLS.USERS.EMPLOYEE.CREATE_EMERGENCY_CONTACT,
      userData,
      data?.token
    );
    if (
      resp?.status >= 200 &&
      resp?.status < 300 &&
      resp?.data &&
      resp?.data.success
    ) {
      yield put(storeEmergencyContact(resp?.data.data));
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);

    } else {
      yield put(turnOffLoading());
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    yield put(turnOffLoading());
    action &&
      action.callbackError &&
      action.callbackError(e && e?.data ? e?.data : e);
  }
}



export function* listUsersForConversationSaga(action) {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URLS.USERS.CONVERSATION.USER_LIST, data?.data, data?.token)
    if (resp && resp?.status && resp?.status >= 200 && resp?.status < 300 && resp?.data && resp?.data?.success) {
      //console.log("Storing Chat User")
      yield put(storeAllConversationUsersList(resp?.data?.data?.data))
      action && action.callbackSuccess && action.callbackSuccess(resp?.data);
    } else {
      action && action.callbackError && action.callbackError(resp?.data);
    }
  } catch (e) {
    action && action.callbackError && action.callbackError(e && e?.data ? e?.data : e);
  }
}

